import React from "react";
import { motion } from "framer-motion";
import { CalendarCheck, Lightning } from "@phosphor-icons/react";

export const Compliance = () => {
  return (
    <section
      id="compliance"
      data-testid="compliance-section"
      className="relative py-20 sm:py-24"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="relative rounded-3xl bg-white border border-bone-200 overflow-hidden"
        >
          <div className="absolute inset-0 bg-topo opacity-40 pointer-events-none" />
          <div className="absolute -top-24 -left-20 w-72 h-72 bg-forest-50 rounded-full blur-3xl opacity-70" />

          <div className="relative grid grid-cols-1 md:grid-cols-5 gap-8 p-8 sm:p-10 lg:p-14">
            <div className="md:col-span-2">
              <div className="text-xs font-semibold uppercase tracking-[0.2em] text-terracotta mb-3">
                Rechtsgrundlage
              </div>
              <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-forest-900 tracking-tight">
                Pflicht für alle gewerblichen PSM-Anwender.
              </h2>
              <p className="mt-4 font-body text-[15px] sm:text-base text-[#4A524C] max-w-md">
                EU&nbsp;1107/2009 · § 11 PflSchG · Durchführungsverordnung
                (EU)&nbsp;2023/564 · Verlängerung über (EU)&nbsp;2025/2203.
              </p>
            </div>

            <div className="md:col-span-3 space-y-5">
              <TimelineCard
                Icon={CalendarCheck}
                date="Seit 01.01.2026"
                title="Umfassende Dokumentation Pflicht"
                desc="Alle PSM-Anwendungen müssen vollständig und lückenlos nach EU 2023/564 erfasst werden, mit erweiterten Pflichtfeldern."
                testId="compliance-2026"
              />
              <TimelineCard
                Icon={Lightning}
                date="Ab 01.01.2027"
                title="Elektronisch &amp; maschinenlesbar"
                desc="Die Aufzeichnungen müssen EU-weit in einem elektronischen, maschinenlesbaren Format geführt werden. Plantus liefert dieses Format bereits heute."
                testId="compliance-2027"
                highlight
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

const TimelineCard = ({ Icon, date, title, desc, highlight = false, testId }) => (
  <div
    data-testid={testId}
    className={`relative rounded-2xl p-5 sm:p-6 border ${
      highlight
        ? "bg-forest-700 text-white border-forest-700"
        : "bg-bone border-bone-200"
    }`}
  >
    <div className="flex items-start gap-4">
      <div
        className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${
          highlight ? "bg-white/10 border border-white/15" : "bg-forest-50 border border-forest-100"
        }`}
      >
        <Icon
          size={20}
          weight="duotone"
          className={highlight ? "text-white" : "text-forest-700"}
        />
      </div>
      <div className="flex-1 min-w-0">
        <div
          className={`text-[11px] font-semibold uppercase tracking-[0.18em] ${
            highlight ? "text-terracotta" : "text-terracotta"
          }`}
        >
          {date}
        </div>
        <h3
          className={`mt-1 font-heading text-lg sm:text-xl font-medium ${
            highlight ? "text-white" : "text-forest-900"
          }`}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <p
          className={`mt-2 font-body text-[14px] sm:text-[15px] leading-relaxed ${
            highlight ? "text-white/75" : "text-[#4A524C]"
          }`}
        >
          {desc}
        </p>
      </div>
    </div>
  </div>
);
